import { Team, TeamMember } from '@demind-inc/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { teamApi } from '../api';
import { TEAM_DAY_QUERY_KEY, TEAM_DETAIL_QUERY_KEY, TEAM_LIST_QUERY_KEY } from '../queries';

interface LeaveTeamResult {
  team: Team;
  membership: TeamMember;
}

export const useLeaveTeam = () => {
  const queryClient = useQueryClient();

  const leaveTeamMutation = useMutation({
    mutationFn: (teamId: string) => {
      return teamApi.leaveTeam(teamId).then(({ data }) => {
        return {
          team: data.team as Team,
          membership: data.membership as TeamMember,
        } as LeaveTeamResult;
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DAY_QUERY_KEY });
    },
  });

  return {
    leaveTeam: leaveTeamMutation.mutateAsync,
    isLeavingTeam: leaveTeamMutation.isPending,
    ...leaveTeamMutation,
  };
};
